export const GLOBAL = {
  COMPANY_NAME: 'SoftwareCo',
  PROJECT_NAME: 'HRX',
  VERIFY: 'Verify my account',
  RESEND: 'Resend a new code.',
  RECEIVED: " Haven't received it?",
  VERIFICATION: 'Verification',
  ACCOUNT: "Don't have an account yet?",
  EDIT: 'Edit',
  ADD: 'Add',
  LEAVE_BALANCE_CONTENT: 'Are you sure you want to Delete Leave Balance ?',
  DELETE_LEAVE_BALANCE: 'Delete Leave Balance',
  HRX_HEADING: 'Software Co',
  ROW: 'Rows Par Page:',
  LOADING: 'Loading...',
  PROFILE: 'Profile',
  BACK_HOME: 'Back to Home',
  PAGE_NOT_FOUNT: 'OOPS! PAGE NOT FOUND',
  BACKSPACE: 'Backspace',
  DESC: 'desc',
  ASC: 'asc',
  EMPLOYEE_TYPE: 'employee',
  DESIGNATION_TYPE: 'designation',
  DEPARTMENT_TYPE: 'department',
  NO_DATA: 'There are no records to display',
  CONTENT:
    " Sorry, the page you're looking for doesn't exist. If you think something is broken,report a problem.",
  NO_FILES_AVAILABLE: 'No files available',
  NO_KPI_FOUND: 'No KPI found'
};

export const WORK_SHOW_STORAGE_KEY = 'hrx-selected-work-show';

export const WORK_SHOWS = [
  {
    id: 'ahmedabad',
    label: 'Ahmedabad',
    shortLabel: 'AMD',
    region: 'India',
    countryCode: 'IN',
    timezone: 'IST',
    ianaTimezone: 'Asia/Kolkata'
  },
  {
    id: 'australia',
    label: 'Australia',
    shortLabel: 'AUS',
    region: 'Australia',
    countryCode: 'AU',
    timezone: 'AEST',
    ianaTimezone: 'Australia/Sydney'
  }
];

export const getWorkShowById = (workShowId) =>
  WORK_SHOWS.find((ws) => ws.id === workShowId) || WORK_SHOWS[0];

export const getWorkShowLocality = (workShowId) => [getWorkShowById(workShowId).countryCode];

export const getWorkShowIanaTimezone = (workShowId) =>
  getWorkShowById(workShowId).ianaTimezone || 'Asia/Kolkata';

/** Map profile locality to sidebar office id (ahmedabad / australia). */
export const getWorkShowIdByLocality = (localityValue) => {
  const codes = normalizeUserLocality(localityValue);
  if (codes.includes('AU')) {
    return WORK_SHOWS.find((ws) => ws.countryCode === 'AU')?.id ?? WORK_SHOWS[0].id;
  }
  if (codes.includes('IN')) {
    return WORK_SHOWS.find((ws) => ws.countryCode === 'IN')?.id ?? WORK_SHOWS[0].id;
  }
  return WORK_SHOWS[0].id;
};

/** @deprecated Use getWorkShowLocality */
export const getWorkShowNationality = getWorkShowLocality;

export const HOLIDAY_LOCALITY_OPTIONS = WORK_SHOWS.map((ws) => ({
  value: ws.countryCode,
  label: `${ws.region} (${ws.countryCode})`
}));

/** @deprecated Use HOLIDAY_LOCALITY_OPTIONS */
export const HOLIDAY_NATIONALITY_OPTIONS = HOLIDAY_LOCALITY_OPTIONS;

/** Map profile locality (name or code) to API country codes e.g. IN, AU */
export const normalizeUserLocality = (value) => {
  if (value == null || value === '') return [];
  const values = Array.isArray(value) ? value : [value];
  const codes = values.map((item) => normalizeNationalityCode(item)).filter(Boolean);
  return [...new Set(codes)];
};

/** @deprecated Use normalizeUserLocality */
export const normalizeUserNationality = normalizeUserLocality;

export const getRecordLocality = (record) => {
  const value = record?.locality ?? record?.nationality;
  if (Array.isArray(value)) return value;
  if (value == null || value === '') return [];
  return [value];
};

const normalizeNationalityCode = (value) => {
  const raw = String(value).trim();
  if (!raw) return null;
  const upper = raw.toUpperCase();

  const byCode = WORK_SHOWS.find((ws) => ws.countryCode === upper);
  if (byCode) return byCode.countryCode;

  const lower = raw.toLowerCase();
  const byRegion = WORK_SHOWS.find(
    (ws) =>
      ws.region.toLowerCase() === lower ||
      ws.label.toLowerCase() === lower ||
      ws.id.toLowerCase() === lower
  );
  if (byRegion) return byRegion.countryCode;

  if (lower === 'india' || lower === 'indian') return 'IN';
  if (lower === 'australia' || lower === 'australian') return 'AU';

  return upper.length <= 3 ? upper : null;
};

export const ROLES = {
  ADMIN: 'Admin',
  EMPLOYEE: 'Employee',
  MANAGEMENT: 'Management',
  LEAD: 'Lead',
  HR: 'HR',
  EM: 'Engineering Manager',
  ACCOUNTANT: 'Accountant'
};

/** Role names that share Admin + HR privileges (use with `.includes(roleName)`). */
export const ADMIN_HR_ROLES = [ROLES.ADMIN, ROLES.HR, ROLES.ACCOUNTANT];

export const VALIDATION_DAY = {
  SUN: 'Sun',
  SAT: 'Sat',
  F_HALF: '1st Half',
  S_HALF: '2nd Half',
  HALF_DAY: 'Half Day',
  FULL_DAY: 'Full Day'
};

export const LEAVE_STATUS = {
  REJECTED: 'Rejected',
  ACCEPTED: 'Approved',
  PENDING: 'Pending'
};

export const EFFECTIVE_FROM = {
  DATE_OF_JOINING: 'Date of Joining',
  DATE_OF_CONFIRMATION: 'Date of Confirmation'
};

export const EFFECTIVE_PERIOD = {
  MONTH: 'Month',
  YEAR: 'Year'
};

export const LEAVE_BALANCE_BASED_ON = {
  ENTITLEMENT: 'Entitlement',
  GRANT: 'Grant'
};

export const TYPE_OPTION = [
  { label: 'Select Type', value: '' },
  { label: 'Month', value: 'Month' },
  { label: 'Year', value: 'Year' }
];

export const EMPLOYEE_TYPE_OPTION = [
  { label: 'Select Employee Type', value: '' },
  { label: 'Full Time', value: 'Full Time' },
  { label: 'Part Time', value: 'Part Time' }
];

export const FROM_OPTION = [
  { label: 'From', value: '' },
  { label: 'Date of Joining', value: 'Date of Joining' },
  { label: 'Date of Confirmation', value: 'Date of Confirmation' }
];

export const ACCRUAL_OPTION = [
  { label: ' Current Accrual', value: '' },
  { label: 'Month', value: 'Month' },
  { label: 'Year', value: 'Year' }
];

export const LEAVE_DAY_TYPE = [
  { label: 'Full Day', value: 'Full Day' },
  { label: 'Half Day', value: 'Half Day' }
];

export const WEEKEND_TYPE = [{ label: 'Weekend', value: 'Weekend' }];
export const HOLIDAY_TYPE = [{ label: 'HoliDay', value: 'HoliDay' }];

export const HALF_TYPE = [
  { label: '', value: '' },
  { label: '1st Half', value: '1st Half' },
  { label: '2nd Half', value: '2nd Half' }
];

export const TABLE_ROW = [
  { label: 5, value: 5 },
  { label: 10, value: 10 },
  { label: 20, value: 20 },
  { label: 30, value: 30 }
];

export const REGEX = {
  NUMBER: /^[0-9]*$/
};

export const MONTHS = [
  'jan',
  'feb',
  'mar',
  'apr',
  'may',
  'jun',
  'jul',
  'aug',
  'sep',
  'oct',
  'nov',
  'dec'
];

export const DEPARTMENT_KEYS = {
  MANAGEMENT: 'Management',
  FINANCE: 'Finance',
  PROJECT_MANAGEMENT: 'Project Management',
  DEVELOPMENT: 'Development',
  QA: 'QA',
  DESIGN: 'Design',
  HR: 'Human Resource'
};

export const NOTIFICATION_TYPES_KEYS = {
  NT_SUPPORT_TICKET: 'supportTicket',
  NT_LEAVE_REQUEST: 'leaveRequest',
  NT_ANNOUNCEMENT: 'announcement',
  NT_HOLIDAY: 'holiday',
  NT_PERFORMANCE_REVIEW: 'perforceReview'
};

export const DATE_FILTER_KEYS = {
  TODAY: 'Today',
  THIS_WEEK: 'This Week',
  THIS_MONTH: 'This Month',
  THIS_YEAR: 'This Year',
  CUSTOM: 'Custom'
};

export const DATE_FILTER = [
  { label: DATE_FILTER_KEYS.TODAY, value: DATE_FILTER_KEYS.TODAY },
  { label: DATE_FILTER_KEYS.THIS_WEEK, value: DATE_FILTER_KEYS.THIS_WEEK },
  { label: DATE_FILTER_KEYS.THIS_MONTH, value: DATE_FILTER_KEYS.THIS_MONTH },
  { label: DATE_FILTER_KEYS.THIS_YEAR, value: DATE_FILTER_KEYS.THIS_YEAR },
  { label: DATE_FILTER_KEYS.CUSTOM, value: DATE_FILTER_KEYS.CUSTOM }
];

export const CALENDAR_MONTHS = [
  {
    name: 'January',
    id: 0
  },
  {
    name: 'February',
    id: 1
  },
  {
    name: 'March',
    id: 2
  },
  {
    name: 'April',
    id: 3
  },
  {
    name: 'May',
    id: 4
  },
  {
    name: 'June',
    id: 5
  },
  {
    name: 'July',
    id: 6
  },
  {
    name: 'August',
    id: 7
  },
  {
    name: 'September',
    id: 8
  },
  {
    name: 'October',
    id: 9
  },
  {
    name: 'November',
    id: 10
  },
  {
    name: 'December',
    id: 11
  }
];

export const KPI_START_YEAR = 2024;

export const PAYROLL_CATEGORY = {
  LOP: 'LOP',
  OVERTIME: 'Overtime',
  COMPASSIONATE: 'Compensate'
};

export const LOP_OVERTIME_TYPE = [
  { label: PAYROLL_CATEGORY.LOP, value: PAYROLL_CATEGORY.LOP },
  { label: PAYROLL_CATEGORY.OVERTIME, value: PAYROLL_CATEGORY.OVERTIME },
  { label: PAYROLL_CATEGORY.COMPASSIONATE, value: PAYROLL_CATEGORY.COMPASSIONATE }
];

export const LOP_AND_OVERTIME_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected'
};

export const COMPLAIN_STATUS = {
  REJECTED: 'Rejected',
  ACCEPTED: 'Approved',
  PENDING: 'Pending'
};

export const LEAVE_TYPES = {
  COMPENSATORY_LEAVES: 'Compensatory Leave',
  WFH: 'WFH',
  UNPAID_LEAVES: 'Unpaid Leave'
};

export const WORK_DURATION_STATUS = {
  FULL_DAY: 'FullDay',
  HALF_DAY: 'HalfDay',
  LESS_THAN_HALF_DAY: 'LessThanHalfDay',
  NOT_WORKING: 'NotWorking',
  WEEKENDS: 'Weekends'
};

export const ARRIVAL_STATUS = {
  LATE: 'Late',
  ON_TIME: 'OnTime',
  NOT_WORKING: 'NotWorking',
  WEEKENDS: 'Weekends'
};

export const START_ACTIVITY_STATUS = {
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  PENDING: 'Pending',
  VOIDED: 'Voided'
};
